var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "body-container split-viewport" },
    [
      _c(
        "div",
        { staticClass: "viewport viewport-left" },
        [
          _c("view-room-details-title"),
          _vm._v(" "),
          _vm._t("artwork"),
          _vm._v(" "),
          _c("view-room-details-quick-details"),
          _vm._v(" "),
          "T" === _vm.$store.getters.currentRoomWingCode
            ? _c(
                "view-room-details-expand-contract",
                {
                  ref: "renovations",
                  staticClass: "expand_contract--container-renovations",
                  attrs: { title: "Tuscany Tower Renovations" },
                },
                [
                  _c("div", { staticClass: "body-container tab" }, [
                    _c("img", {
                      attrs: {
                        src: "/library/images/view-room-details/peppermill-tower-renovation.jpg",
                        width: "700",
                        height: "200",
                        alt: "Tuscany Tower Renovations",
                      },
                    }),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "In our commitment to offering the most luxurious and innovative hospitality experiences, we are excited to\n          announce a transformation of our Tuscany Tower suites. During this renovation, we are dedicated to minimizing\n          any impact on your stay. We sincerely apologize for any inconvenience this project may cause and appreciate\n          your understanding as we elevate your future visits to new heights."
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "view-room-details-expand-contract",
            {
              staticClass: "expand_contract--container-room_description",
              attrs: { title: "Room Description" },
            },
            [_vm._t("roomDescription")],
            2
          ),
          _vm._v(" "),
          _c(
            "view-room-details-expand-contract",
            {
              staticClass: "expand_contract--container-room_amenities",
              attrs: { title: "Services & Amenities" },
            },
            [_vm._t("roomAmenities")],
            2
          ),
          _vm._v(" "),
          _c("view-room-details-expand-contract", {
            staticClass: "expand_contract--container-similar_rooms",
            attrs: { isSimilarRooms: "", title: "Similar Rooms" },
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "viewport viewport-right" },
        [
          _c("view-room-details-table", {
            ref: "table",
            attrs: { "preferred-rate-difference": _vm.preferredRateDifference },
          }),
          _vm._v(" "),
          _c("view-room-details-travel-agent-form"),
          _vm._v(" "),
          _c("view-room-details-preferred-onboard-form", {
            attrs: { "preferred-rate-difference": _vm.preferredRateDifference },
            on: { checkpreferred: _vm.checkIfUserIsLoggedIntoPreferred },
          }),
          _vm._v(" "),
          "T" === _vm.$store.getters.currentRoomWingCode
            ? _c(
                "div",
                {
                  staticClass: "view_room_details--renovations_cta",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.openRenovations.apply(null, arguments)
                    },
                  },
                },
                [_vm._m(0)]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("view-room-details-book-button", {
            attrs: {
              "reservation-total": _vm.currentTotalNonPreferred,
              preferredSavings: _vm.preferredRateDifference,
              "showing-preferred-offer":
                _vm.$store.getters.showingPreferredOffer,
            },
            on: {
              "update:showSimilarRooms": function ($event) {
                return _vm.$store.commit("updateState", [
                  "showSimilarRooms",
                  $event,
                ])
              },
              "update:similarRoomTowerOmit": function ($event) {
                return _vm.$store.commit("updateState", [
                  "similarRoomTowerOmit",
                  $event,
                ])
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.$store.getters.currentRoomType &&
      _vm.$store.getters.currentRoomType.DISPLAY
        ? _c("peppermill-dialog", {
            attrs: {
              active: _vm.$store.state.isVariantDialogVisible,
              title: "Room Options",
              "is-alert": "",
            },
            on: {
              close: function ($event) {
                return _vm.$store.commit("updateState", [
                  "isVariantDialogVisible",
                  false,
                ])
              },
              cancel: function ($event) {
                return _vm.$store.commit("updateState", [
                  "isVariantDialogVisible",
                  false,
                ])
              },
              submit: function ($event) {
                return _vm.$store.commit("updateState", [
                  "isVariantDialogVisible",
                  false,
                ])
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("p", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.$store.getters.currentRoomTypeTitleData
                                ?.ROOM_TITLE || ""
                            )
                          ),
                        ]),
                        _vm._v(" has multiple options, choose\n        one:"),
                      ]),
                      _vm._v(" "),
                      _vm._l(
                        _vm.$store.state.roomData,
                        function (roomTypeVariant) {
                          return roomTypeVariant.DISPLAY
                            ? _c("p", { key: roomTypeVariant.PRT_ID }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn room_variant--button",
                                    class: {
                                      "btn-highlight":
                                        roomTypeVariant.PRT_ID ===
                                        _vm.$store.getters.currentRoomType
                                          ?.PRT_ID,
                                      "room_variant--button-icon":
                                        roomTypeVariant.DISPLAY.ROOM_SMOKING ||
                                        roomTypeVariant.DISPLAY
                                          .ROOM_NON_SMOKING ||
                                        roomTypeVariant.DISPLAY.ROOM_ADA,
                                    },
                                    attrs: {
                                      href: "#",
                                      title:
                                        "Click to book " +
                                        _vm.getRoomVariantTitle(
                                          roomTypeVariant
                                        ) +
                                        "room",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        _vm.handleVariantSelection(
                                          roomTypeVariant,
                                          _vm.getRoomVariantTitle(
                                            roomTypeVariant
                                          )
                                        )
                                      },
                                    },
                                  },
                                  [
                                    roomTypeVariant.DISPLAY.ROOM_SMOKING
                                      ? _c("span", {
                                          staticClass:
                                            "icon room_icon--container room_icon--container-smoking",
                                          attrs: { "aria-hidden": "true" },
                                        })
                                      : roomTypeVariant.DISPLAY.ROOM_NON_SMOKING
                                      ? _c("span", {
                                          staticClass:
                                            "icon room_icon--container room_icon--container-non_smoking",
                                          attrs: { "aria-hidden": "true" },
                                        })
                                      : roomTypeVariant.DISPLAY.ROOM_ADA
                                      ? _c("span", {
                                          staticClass:
                                            "icon room_icon--container room_icon--container-ada",
                                          attrs: { "aria-hidden": "true" },
                                        })
                                      : _vm._e(),
                                    _vm._v(
                                      "\n\n          " +
                                        _vm._s(
                                          _vm.getRoomVariantTitle(
                                            roomTypeVariant
                                          )
                                        ) +
                                        "\n\n          "
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "room_variant--price_difference",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getRoomVariantPriceDifference(
                                              roomTypeVariant
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e()
                        }
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              1543744187
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("h3", [
      _c("span", { staticClass: "mobile-hidden" }, [_vm._v("Tuscany Tower")]),
      _vm._v(" Renovations"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }